export enum EldPermissions {
  ImportLog = 'import-log',
}
